<template>
    <div class="message-bubble group">
        <div class="message-bubble-body__profile" @click="showProfileCard">
            <img :src="img" v-if="img">
            <div class="initials" :style="{background: color}">
                {{ initials }}
            </div>
        </div>
        <div class="message-bubble-body">
            <div class="message-bubble-body__text">
                <div class="text">
                    {{ text }}
                </div>
                <div class="message-bubble-body__time">
                    <span v-if="time">{{ time }}</span>
                    <clocks v-else-if="message.isSending()"></clocks>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Message from "../../models/Messages/Message";
    import Clocks from "../svg/Clocks";
    import {EventBus} from "@common/EventBus";

    export default {
        name: "PlainMessage",
        components: {Clocks},
        props: {
            message: {
                type: Message,
                required: true
            },
        },
        computed: {
            time() {
                return (this.message && !this.message.status && this.message.createdAt)
                    ? this.message.createdAt.toFormat('HH:mm')
                    : '';
            },
            user() {
                return this.$store.state.chat.profiles.list[this.message.userID] || null;
            },
            text() {
                let name = this.user ? this.user.fullName() : '',
                    message = '';
                if (this.message.isIn()) {
                    message = this.message.notificationBodyIn(name);
                }
                else {
                    message = this.message.notificationBodyOut(name);
                }
                return message;
            },
            img() {
                return this.user && this.user.photoUrl(this.$store.state.session);
            },
            color() {
                return this.user ? this.user.color() : this.room.color();
            },
            initials() {
                return this.user ? this.user.initials() : '';
            }
        },
        methods: {
            showProfileCard() {
                EventBus.$emit('showChatByUserId', this.message.userID);
            }
        }
    }
</script>

<style scoped>

</style>
